import { createContext, useContext } from 'react';
const AuthContext = /*#__PURE__*/createContext({});
export const AuthProvider = AuthContext.Provider;
export function useAuth() {
  return useContext(AuthContext);
}
export function useIsUngated(gateName) {
  const {
    gates
  } = useAuth();
  return gates === null || gates === void 0 ? void 0 : gates.includes(gateName);
}